import styled from 'styled-components';

export const UploadWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacings.abs24}px;
`;
